/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Text } from '@chakra-ui/react';

export default function CardReason({ reason = null }) {
	return <Text>{reason ?? 'N/A'}</Text>;
}
